/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Canrepresent1Inputs */

const en_entity_canrepresent1 = /** @type {(inputs: Entity_Canrepresent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can Represent`)
};

const de_entity_canrepresent1 = /** @type {(inputs: Entity_Canrepresent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann vertreten`)
};

/**
* | output |
* | --- |
* | "Can Represent" |
*
* @param {Entity_Canrepresent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_canrepresent1 = /** @type {((inputs?: Entity_Canrepresent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Canrepresent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_canrepresent1(inputs)
	return de_entity_canrepresent1(inputs)
});
export { entity_canrepresent1 as "entity_canRepresent" }